import { render, staticRenderFns } from "./NameStatusFull.vue?vue&type=template&id=57d28dcd"
import script from "./NameStatusFull.vue?vue&type=script&lang=js"
export * from "./NameStatusFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports